import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { Card } from "../common/Card";
import { SubscriberGrowthChartShimmer } from "../../common/reportDashBShimmer/SubscriberGrowthChartShimmer";

export function SubscriptionGrowthSection({ loading, growthData }) {
  return (
    <Card className="p-6 bg-white rounded-lg shadow-sm border border-gray-100">
      <span className="mb-6 text-[#1A1A1A] text-lg">
        Subscriber Growth Trend
      </span>
      {loading ? (
        <SubscriberGrowthChartShimmer />
      ) : growthData?.length > 0 ? (
        <ResponsiveContainer width="100%" height={350}>
          <LineChart data={growthData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
            <XAxis dataKey="month" stroke="#6B7280" />
            <YAxis stroke="#6B7280" />
            <Tooltip
              contentStyle={{
                backgroundColor: "white",
                border: "1px solid #E5E7EB",
                borderRadius: "8px",
              }}
            />
            <Legend />
            <Line
              type="monotone"
              dataKey="totalSubscribers"
              stroke="#1E61DC"
              strokeWidth={3}
              name="Total Subscribers"
            />
            <Line
              type="monotone"
              dataKey="new"
              stroke="#10B981"
              strokeWidth={2}
              name="New"
            />
            <Line
              type="monotone"
              dataKey="churned"
              stroke="#EF4444"
              strokeWidth={2}
              name="Churned"
            />
          </LineChart>
        </ResponsiveContainer>
      ) : (
        <div className="h-[350px] flex items-center justify-center text-gray-500">
          No subscriber growth data available
        </div>
      )}
    </Card>
  );
}
